// useLocationObj /////////////////////////////////////////////////////////////
//
// This is a hook for extracting information out of the query path.
///////////////////////////////////////////////////////////////////////////////

// SETUP //////////////////////////////////////////////////////////////////////
// Third-party imports.
import { useEffect, useState, } from 'react'
import { useLocation, } from 'react-router-dom'
import { parse as parseQueryString, } from 'query-string'

// Local imports.
import { type AppQuery, type AppQueryObject } from '../types/AppRouter'


// MAIN FUNCTION //////////////////////////////////////////////////////////////
/**
 * Parse the query path and return an object that contains search information
 * and a pathname.
 * 
 * @returns [ search, pathname, ]
 */
function useLocationObj () {
  const [ queryObj, setQueryObj, ] = useState<AppQueryObject>({ pathname: '', })
  const { search, pathname, } = useLocation()

  // USE EFFECT ///////////////////////////////////////////////////////////////
  // Generate the query object.
  useEffect(() => {
    const qo : AppQueryObject = { pathname: pathname || '', }
    if (search) {
      const so = parseQueryString(search) as AppQuery;
      qo['search'] = so
    }
    setQueryObj(qo)
  }, [ search, pathname, ])


  return queryObj
}

export default useLocationObj;